import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICandidate } from '../interface/dto';
import { AuthService } from './http-services/authservice.service';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TableParams } from '../components/grid/TableParams';
declare const $: any;

@Injectable({
    providedIn: 'root'
})
export class CompanyService {

    constructor(private httpClient: HttpClient, private auth: AuthService) { }
    configureHeaders() {
        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/json');
        headers = headers.set('Authorization', `Bearer ${this.auth.token}`);
        return headers;
    }

    async getCompanyExtendedInfo(company) {
        return this.httpClient.get(
            `${environment.apiURL}Company/extendedInfo?company=${company}`, { headers: this.configureHeaders() }).toPromise();
    }
    async updateInstructions(data) {
        return this.httpClient.put(
            `${environment.apiURL}Company/updateInstructions`, data, { headers: this.configureHeaders() }).toPromise();
    }
    async uploadLogo(data: FormData) {
        let header = new HttpHeaders({
            'Content-Disposition': 'multipart/form-data',
            "Authorization": `Bearer ${this.auth.token}`
        });
        return this.httpClient.post(`${environment.apiURL}Company/upload-logo`, data, { headers: header }).toPromise();
    }

}
